export default __webpack_public_path__ + "static/media/cutting-stones.4665699c.yaml";